import * as React from "react";
import { observer } from "mobx-react";
import { FormGroup, Label, FormText, FormFeedback } from 'reactstrap';


@observer
export class Field extends React.Component<any> {
    getValue() {
        return this.props.store.getValue(this.props.name);
    }

    getError() {
        return this.props.store.getError(this.props.name);
    }

    onChange = (newValue: any) => {
        const value = newValue !== null && newValue.target ? newValue.target : newValue;

        if (this.props.returnObject) {
            this.props.store.setValue(this.props.name, value ? value.value : value);
        } else {
            this.props.store.setValue(this.props.name, value);
        }

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
        const { component, label, helpText, store, onChange, ...fieldProps } = this.props;
        const error = this.getError();

        const fieldComponent = React.createElement(component, {
            ...fieldProps,
            onChange: this.onChange,
            value: this.getValue(),
            invalid: !!error
        });

        const labelComponent = !!label && (
            <Label for={this.props.name}>
                {label}{this.props.required && <em>* </em>}
            </Label>
        );

        const Wrapper = !this.props.inline ? FormGroup : React.Fragment;

        return (
            <Wrapper>
                {labelComponent}
                {fieldComponent}
                <FormFeedback style={{display: error ? "block" : "none"}}>{error}</FormFeedback>
                {helpText && (
                    <FormText color="muted">
                        {helpText}
                    </FormText>
                )}
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/Field.tsx